import { createSlice } from '@reduxjs/toolkit';

export const interactionSlice = createSlice({
    name: 'interactions',
    initialState: {
        toast: {
            open: false
        },
        loader: {
            visible: false
        }
    },
    reducers: {
        showToast: (state, {payload}) =>  {
            state.toast = { open: true, ...payload }
        },
        hideToast: (state) =>  {
            state.toast = { ...state.toast, open: false }
        },
        showLoader: (state) => {
            state.loader = { visible: true }
        },
        hideLoader: (state) => {
            state.loader = { visible: false }
        },
    },
})

export const { showToast, hideToast, showLoader, hideLoader } = interactionSlice.actions;

export default interactionSlice.reducer;